import { Component, inject, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LoginService } from '@core/login/services/login.service';
import { IRole } from '@features/users/models/role';
import { UserService } from '@features/users/services/user.service';
import { IBaseUser } from '@shared/models/base-user';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
})
export class NavbarComponent implements OnInit {
  protected loginSrv: LoginService = inject(LoginService);
  private readonly userSrv: UserService = inject(UserService);

  protected loggedUser: IBaseUser | null;
  protected userRoleValue: string | null = null;

  constructor() {
    this.loggedUser = this.loginSrv.getLoggedUserFromLocalStorage();
  }

  ngOnInit(): void {
    if (this.loggedUser) {
      this.userSrv.getUserById(this.loggedUser.id).subscribe({
        next: (response) => {
          if (response.data?.backofficeUser?.backofficeRoles?.[0]?.role?.value) {
            this.userRoleValue =
              response.data.backofficeUser.backofficeRoles[0].role.value;
          } else {
            console.error('No se encontró el valor del rol en la respuesta.');
          }
        },
        error: (error) => {
          console.error('Error al obtener el usuario:', error);
        },
      });
    } else {
      console.error('No hay un usuario logueado.');
    }
  }
}
